<h2 mat-dialog-title>Add In-Port Days</h2>

<mat-dialog-content>
    <p class="hint">
        A daily fishing log entry will be created for <b>each day</b> in the range below, with
        <b>Fishing Mode</b> set to <b>In Port</b> and <b>Hours Fished</b> set to <b>0</b>. The gear details
        below are applied to every day.
    </p>

    <!-- Date range -->
    <form [formGroup]="range">
        <mat-form-field appearance="fill" class="full-width">
            <mat-label>Date Range</mat-label>
            <mat-date-range-input [rangePicker]="picker">
                <input matStartDate formControlName="start" placeholder="Start date" (click)="picker.open()" readonly />
                <input matEndDate formControlName="end" placeholder="End date" (click)="picker.open()" readonly />
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
            <mat-error *ngIf="range.invalid">Start and end date are required</mat-error>
        </mat-form-field>
    </form>

    <!-- Gear + gear-dependent required fields -->
    <form [formGroup]="gearForm">
        <mat-form-field appearance="fill" class="full-width">
            <mat-label>Gear</mat-label>
            <mat-select formControlName="gear" required>
                <mat-option *ngFor="let gear of gearOptions" [value]="gear">{{ gear }}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field *ngIf="isDSBG" appearance="fill" class="full-width">
            <mat-label>DSBG Type</mat-label>
            <mat-select formControlName="dsbgType" [compareWith]="compareDSBGtype" required>
                <mat-option *ngFor="let sub of gearSubtypes" [value]="sub">{{ sub.name }}</mat-option>
            </mat-select>
        </mat-form-field>

        <div *ngIf="isDSBG" class="dsbg-counts">
            <mat-form-field appearance="fill">
                <mat-label>Total # of Buoys</mat-label>
                <input
                    matInput
                    type="text"
                    inputmode="numeric"
                    formControlName="numBuoys"
                    (input)="numericOnly(gearForm.get('numBuoys')!)"
                />
                <mat-error *ngIf="gearForm.get('numBuoys')!.hasError('max')">Must be 10 or less</mat-error>
            </mat-form-field>
            <mat-form-field appearance="fill">
                <mat-label>Total # of Hooks</mat-label>
                <input
                    matInput
                    type="text"
                    inputmode="numeric"
                    formControlName="numHooks"
                    (input)="numericOnly(gearForm.get('numHooks')!)"
                />
                <mat-error *ngIf="gearForm.get('numHooks')!.hasError('max')">Must be 30 or less</mat-error>
            </mat-form-field>
        </div>

        <div *ngIf="isHarpoon" class="aircraft">
            <mat-label class="aircraft-label">Aircraft Used?</mat-label>
            <mat-radio-group formControlName="aircraftUsed" class="aircraft-radios">
                <mat-radio-button [value]="true">Yes</mat-radio-button>
                <mat-radio-button [value]="false">No</mat-radio-button>
            </mat-radio-group>
        </div>
    </form>

    <!-- Optional location, applied to every generated day -->
    <mat-form-field appearance="fill" class="full-width">
        <mat-label>Latitude</mat-label>
        <input matInput readonly placeholder="Optional" [value]="lat.toString()" (click)="openCoordinateDialog('lat')" />
        <button
            mat-mini-fab
            matSuffix
            class="blue-icon-button"
            style="margin-right: 8px; color: var(--elog-brand-on); background-color: var(--elog-brand)"
            type="button"
            matTooltip="Fill Location"
            matTooltipPosition="below"
            (click)="fillLocation()"
        >
            <mat-icon>pin_drop</mat-icon>
        </button>
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
        <mat-label>Longitude</mat-label>
        <input matInput readonly placeholder="Optional" [value]="lon.toString()" (click)="openCoordinateDialog('lon')" />
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-stroked-button class="text-blue-button" type="button" (click)="onNoClick()">Cancel</button>
    <span style="flex: 1 1 auto;"></span>
    <button mat-stroked-button class="text-button" type="button" (click)="confirm()">Create</button>
</mat-dialog-actions>
